import React, { Fragment, useEffect } from "react";
import { Pagina } from "../template/Template";
import { AuthContext } from "../../App";
import { Formik } from "formik";
import { usuarioChangePwd } from "../../services/UsuarioService";
import { controlesenhaFindAll } from "../../services/ControlesenhaService";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import { ButtonSave } from "../botoes/operacao";
import { useStyles } from "../styles/StyleTrocasenha";

let severity = "success";

export default function Trocasenha() {
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);
    const [errorData, setErrorData] = React.useState("");
    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [controlesenha, setControlesenha] = React.useState({});

    const handleCloseSnackBar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackBar(false);
    };

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    useEffect(() => {
        controlesenhaFindAll(authState, setErrorData).then((controlesenha) => {
            setControlesenha(controlesenha.data[0]);
        });
    }, []);

    const Content = () => {
        return (
            <Fragment>
                <Snackbar
                    open={openSnackBar}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackBar}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                >
                    <Alert onClose={handleCloseSnackBar} severity={severity}>
                        {errorData}
                    </Alert>
                </Snackbar>

                <div className={classes.box}>
                    <Paper className={classes.boxPrancheta} elevation={7}>
                        <Formik
                            initialValues={{
                                usuSenhaAtual: "",
                                usuSenha1: "",
                                usuSenha2: "",
                            }}
                            validate={(values) => {
                                const errors = {};
                                if (!values.usuSenhaAtual) {
                                    errors.usuSenhaAtual = "Obrigatório";
                                } else if (!values.usuSenha1) {
                                    errors.usuSenha1 = "Obrigatório";
                                } else if (
                                    values.usuSenha1.length < controlesenha.cos_min_caracter
                                ) {
                                    errors.usuSenha1 =
                                        "Minimo " + controlesenha.cos_min_caracter + " caracteres";
                                } else if (!values.usuSenha2) {
                                    errors.usuSenha1 = "Obrigatório";
                                } else if (
                                    values.usuSenha2.length < controlesenha.cos_min_caracter
                                ) {
                                    errors.usuSenha2 =
                                        "Minimo " + controlesenha.cos_min_caracter + " caracteres";
                                } else if (values.usuSenha1 !== values.usuSenha2) {
                                    errors.usuSenha1 = "Senhas diferentes";
                                } else if (controlesenha.cos_complexa) {
                                    let hasUpperCase = /[A-Z]/.test(values.usuSenha1);
                                    let hasLowerCase = /[a-z]/.test(values.usuSenha1);
                                    let hasNumbers = /\d/.test(values.usuSenha1);
                                    let hasNonalphas = /\W/.test(values.usuSenha1);
                                    if (
                                        hasUpperCase + hasLowerCase + hasNumbers + hasNonalphas <
                                        3
                                    ) {
                                        errors.usuSenha1 = "Senhas não complexas";
                                    }
                                }
                                return errors;
                            }}
                            onSubmit={(values, { setSubmitting, resetForm }) => {
                                setSubmitting(true);
                                const usuario = {
                                    usu_email: authState.email,
                                    usu_senha_atual: values.usuSenhaAtual,
                                    usu_senha: values.usuSenha1,
                                };
                                console.log(usuario);
                                usuarioChangePwd(usuario)
                                    .then((result) => {
                                        resetForm({
                                            values: {
                                                usuSenhaAtual: "",
                                                usuSenha1: "",
                                                usuSenha2: "",
                                            },
                                        });
                                        setErrorData("Senha alterada com sucesso");
                                        severity = "success";
                                        setOpenSnackBar(true);
                                    })
                                    .catch((err) => {
                                        setErrorData("Erro ao alterar a senha");
                                        severity = "error";
                                        setOpenSnackBar(true);
                                    });
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                setFieldValue,
                                isValid,
                            }) => (
                                <form onSubmit={handleSubmit} className={classes.form}>
                                    <div className={classes.input_data}>
                                        <TextField
                                            value={values.usuSenhaAtual}
                                            name="usuSenhaAtual"
                                            type="password"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Senha Atual"
                                            className={classes.nome}
                                            fullWidth
                                            helperText={errors.usuApelido}
                                        />

                                        <TextField
                                            value={values.usuSenha1}
                                            id="usuSenha1"
                                            name="usuSenha1"
                                            type="password"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Nova Senha"
                                            className={classes.nome}
                                            fullWidth
                                            helperText={errors.usuSenha1}
                                        />

                                        <TextField
                                            value={values.usuSenha2}
                                            id="usuSenha2"
                                            name="usuSenha2"
                                            type="password"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Repetir Nova Senha"
                                            fullWidth
                                            className={classes.nome}
                                            helperText={errors.usuSenha2}
                                        />

                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                marginTop: "2rem",
                                            }}
                                        >
                                            <ButtonSave
                                                variant="contained"
                                                size="small"
                                                color="primary"
                                                type="submit"
                                                disabled={!isValid}
                                                style={{
                                                    padding: "10px",
                                                    backgroundColor: "#2471A3",
                                                    color: "white",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                Alterar Senha
                                            </ButtonSave>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </Paper>
                </div>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Pagina
                authState={authState}
                Content={Content}
                HeaderDesc="TROCAR SENHA"
            />
        </Fragment>
    );
}
